import * as React from 'react';
import { ToolbarConfig } from '@tencent/workbench';
import { ActionType } from '@editor/src/js/constants/common-action-type';
import i18n from '@i18next/i18n';
import style from './style.less';

export const config = {
    id: ActionType.EXIT_MASTER_EDIT,
    tipMsg: i18n.t('退出母版'),
    content: i18n.t('退出母版'),
};

export const TOOLBAR_CONFIGS: ToolbarConfig[] = [
    {
        name: config.id,
        tooltip: config.tipMsg,
        style: {
            width: 'auto',
        },
        text: config.content,
        hasArrow: false,
        icon: <div className={style['toolbar-exit-master-edit']} />,
    },
];
